import { themeV2 } from '../dap'; // Import the base theme, without any responsive font sizes applied
import { createTheme, responsiveFontSizes, Theme } from '@mui/material';
import { componentsStyles } from './componentsStyles';
import { midnightBlue, neutral, primaryText, secondaryText } from './colors';
import { TypographyVariantsOptions } from '@mui/material/styles/createTypography';

const intranetTheme: Theme = createTheme({
  ...themeV2,
  palette: {
    ...themeV2.palette,
    // For debug purposes, these brand colors can be used, but it should not be defined in deployed code, as the values will be set IF a brand has defined brand colors
    // brand: {
    //   main: 'deeppink',
    //   contrastText: 'lime',
    // },
    primary: {
      ...themeV2.palette.primary,
      ...midnightBlue,
    },
    grey: {
      ...themeV2.palette.grey,
      ...neutral,
    },
    text: {
      ...themeV2.palette.text,
      primary: primaryText,
      secondary: secondaryText,
    },
    gradient: {
      ...themeV2.palette.gradient,
      // primary: `linear-gradient(282.61deg, ${midnightBlue[900]} 0.09%, ${midnightBlue[800]} 32.38%, ${midnightBlue[700]} 62.89%, ${midnightBlue[600]} 98.77%)`,
    },
  },

  typography: {
    // Reduce font-weight for all headings to 600
    ...Object.entries(themeV2.typography).reduce((curr, [key, value]) => {
      if (![`h1`, `h2`, `h3`, `h4`, `h5`].includes(key)) {
        // Return the same value for non-heading keys
        return { ...curr, [key]: value };
      }
      return { ...curr, [key]: { ...value, fontWeight: 600 } };
    }, {} as TypographyVariantsOptions),
  },
  components: {
    // MuiCssBaseline: {
    //   styleOverrides: {
    //     html: {
    //       overflowX: 'hidden'
    //     },
    //     body: {
    //       width: '100%',
    //       overflowX: 'hidden'
    //     }
    //   }
    // },

    ...themeV2.components,
    ...componentsStyles,
    MuiButton: {
      ...themeV2.components?.MuiButton,
      ...componentsStyles?.MuiButton,
      styleOverrides: {
        ...themeV2.components?.MuiButton?.styleOverrides,
        ...componentsStyles?.MuiButton?.styleOverrides,
        root: [
          // Include existing root styles from themeV2
          ...(themeV2.components?.MuiButton?.styleOverrides?.root
            ? Array.isArray(themeV2.components.MuiButton.styleOverrides.root)
              ? themeV2.components.MuiButton.styleOverrides.root
              : [themeV2.components.MuiButton.styleOverrides.root]
            : []),
          // Include existing root styles from componentsStyles
          ...(componentsStyles?.MuiButton?.styleOverrides?.root
            ? Array.isArray(componentsStyles.MuiButton.styleOverrides.root)
              ? componentsStyles.MuiButton.styleOverrides.root
              : [componentsStyles.MuiButton.styleOverrides.root]
            : []),
          {
            // Display minimum height for all buttons on small screens for accessibility
            '&.MuiButton-containedSizeSmall': {
              [themeV2.breakpoints.down('sm')]: {
                height: 'auto',
                minHeight: '48px',
                padding: themeV2.spacing(1.4, 2.25),
                ...themeV2.typography.body1,
              },
            },
            '&.MuiButton-containedSizeMedium': {
              [themeV2.breakpoints.down('sm')]: {
                height: 'auto',
                minHeight: '48px',
                padding: themeV2.spacing(1.4, 2.25),
                ...themeV2.typography.body1,
              },
            },
          },
        ],
      },
    },
  },
});

export default responsiveFontSizes(intranetTheme, {
  factor: 6,
  breakpoints: ['sm', 'md', 'lg'],
});
